import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

import Breadcrumbs from 'components/breadcrumbs';
import { useChartPalette } from 'components/charts/hooks/use-chart-palette';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import Paper from 'components/paper';
import PlaygroundTabsHeader from 'views/playground/components/playground-tabs-header';
import DataLabSubTabs from 'views/playground/features/data-lab/components/data-lab-sub-tabs';

type Props = {
  children: React.ReactNode;
};

const Canvas = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  width: '100%',
  padding: theme.spacing(6),
}));

const PlaygroundShell: React.FC<Props> = ({ children }) => {
  const chartPalette = useChartPalette();

  return (
    <Canvas>
      <ChartThemeScope>
        <PlaygroundTabsHeader utils={<Breadcrumbs />} />
      </ChartThemeScope>
      <DataLabSubTabs />
      <Paper
        sx={{
          backgroundColor: chartPalette.backgrounds.sunken,
          borderRadius: '16px',
          padding: 6,
        }}>
        {children}
      </Paper>
    </Canvas>
  );
};

const DataLab: React.FC<Props> = ({ children }) => <PlaygroundShell>{children}</PlaygroundShell>;

export default DataLab;
